import { APIS } from '../../utils/apiConfig';
import { createRequestUtility } from '../../utils/httpUtils';
import { HttpService } from '../HttpService/HttpService';

export class CostBreakupService {
  // constructor(private httpService: HttpService) {}
  private makeRequest: ReturnType<typeof createRequestUtility>;

  constructor(private httpService: HttpService) {
    // Initialize makeRequest with the httpService
    this.makeRequest = createRequestUtility(this.httpService);
  }

  // example for other request
  // async getPlatformBrowserData(params: getPlatformBrowserDataParams): Promise<any> {
  //   return this.makeRequest('get', APIS.GET_PLATFORM_BROSWER_DATA(), { params });
  // }

  // async removeUnusedResource(params: any): Promise<any> {
  //   return this.makeRequest('delete', APIS.UNUSED_REMOVE(), params);
  // }

  // async resizeInstance(params: any): Promise<any> {
  //   return this.makeRequest('patch', APIS.RESIZE_INSTANCE(), params);
  // }

  async getDataTransferReport(params: any): Promise<any> {
    return this.makeRequest('post', APIS.GET_COST_USAGE(), params);
  }

  async getDatabaseReport(params: any): Promise<any> {
    return this.makeRequest('post', APIS.GET_COST_USAGE(), params);
  }

  async getInstanceCostReport(params: any): Promise<any> {
    return this.makeRequest('post', APIS.GET_INSTANCE_COST(), params);
  }

  async getContainersReport(params: any): Promise<any> {
    return this.makeRequest('post', APIS.GET_CONTAINERS_COST(), params);
  }

  async getStorageReport(params: any): Promise<any> {
    return this.makeRequest('post', APIS.GET_STORAGE_REPORT(), params);
  }

  async getCloudwatchReport(params: any): Promise<any> {
    return this.makeRequest('post', APIS.GET_CLOUDWATCH_REPORT(), params);
  }

  async getNetworkDeliveryReport(params: any): Promise<any> {
    return this.makeRequest('post', APIS.GET_NETWORK_DELIVERY_REPORT(), params);
  }

  async getSecurityReport(params: any): Promise<any> {
    return this.makeRequest('post', APIS.GET_SECURITY_REPORT(), params);
  }

  async getServerlessReport(params: any): Promise<any> {
    return this.makeRequest('post', APIS.GET_SERVERLESS_REPORT(), params);
  }

  async getAnalyticsReport(params: any): Promise<any> {
    return this.makeRequest('post', APIS.GET_ANALTICS_REPORT(), params);
  }

  async getMigrationTransferReport(params: any): Promise<any> {
    return this.makeRequest('post', APIS.GET_COST_USAGE(), params);
  }

  async getMediaServicesReport(params: any): Promise<any> {
    return this.makeRequest('post', APIS.GET_MEDIA_SERVICES_REPORT(), params);
  }

  async downloadInstanceCostReport(params: string): Promise<any> {
    return this.makeRequest(
      'post',
      APIS.DOWNLOAD_INSTANCE_COST_REPORT(),
      params
    );
  }

  async downloadContainersReport(params: string): Promise<any> {
    return this.makeRequest('post', APIS.DOWNLOAD_CONTAINERS_COST_REPORT(), params);
  }

  async downloadStorageReport(params: string): Promise<any> {
    return this.makeRequest(
      'post',
      APIS.DOWNLOAD_STORAGE_COST_REPORT(),
      params
    );
  }

  async downloadCloudwatchReport(params: string): Promise<any> {
    return this.makeRequest(
      'post',
      APIS.DOWNLOAD_CLOUDWATCH_COST_REPORT(),
      params
    );
  }

  async downloadNetworkDeliveryReport(params: string): Promise<any> {
    return this.makeRequest('post', APIS.DOWNLOAD_NETWORK_COST_REPORT(), params);
  }

  async downloadSecurityReport(params: string): Promise<any> {
    return this.makeRequest('post', APIS.DOWNLOAD_SECURITY_REPORT(), params);
  }

  async downloadServerlessReport(params: string): Promise<any> {
    return this.makeRequest(
      'post',
      APIS.DOWNLOAD_SERVERLESS_COST_REPORT(),
      params
    );
  }

  async downloadAnalyticsReport(params: string): Promise<any> {
    return this.makeRequest('post', APIS.DOWNLOAD_ANALYTICS_COST_REPORT(), params);
  }

  async downloadMigrationTransferReport(params: string): Promise<any> {
    return this.makeRequest('post', APIS.DOWNLOAD_COST_REPORT(), params);
  }

  async downloadMediaServicesReport(params: string): Promise<any> {
    return this.makeRequest('post', APIS.DOWNLOAD_MEDIA_SERVICES_COST_REPORT(), params);
  }
}
